import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const API = '/api';

export default function useReportData(reportId) {
  const [report, setReport] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const loadReport = useCallback(async () => {
    setError(false);
    setLoading(true);

    // Try up to 3 times with increasing delays (handles cold starts)
    const delays = [0, 2000, 4000];
    for (let attempt = 0; attempt < delays.length; attempt++) {
      if (delays[attempt] > 0) {
        await new Promise(r => setTimeout(r, delays[attempt]));
      }
      try {
        const response = await axios.get(`${API}/quiz/report/${reportId}`, { timeout: 15000 });
        if (response.data && response.data.report_id) {
          setReport(response.data);
          setLoading(false);
          return;
        }
      } catch {
        // Continue to next attempt
      }
    }
    // All attempts failed
    setError(true);
    setLoading(false);
  }, [reportId]);

  useEffect(() => {
    loadReport();
  }, [loadReport]);

  return { report, loading, polling: false, reload: loadReport, error };
}
